const getUniqueID = () => {
  return "00000" + new Date().valueOf();
};

const defaultOnChange = () => {
  return;
};

export { getUniqueID, defaultOnChange };
